import { render } from "./NewTrans.vue?vue&type=template&id=20811402&scoped=true"
import script from "./NewTrans.vue?vue&type=script&lang=js"
export * from "./NewTrans.vue?vue&type=script&lang=js"

import "./NewTrans.vue?vue&type=style&index=0&id=20811402&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20811402"]])

export default __exports__